export enum ChatTabsEnum {
  Details,
  TimeLine,
  Contacts,
  Users,
  Search,
  HubSoft,
  Moderna,
  Benner,
  Acelerato,
  InsideSistemas,
  ScheduledMessages,
  ScheduledTask,
  AiAssistant,
  Snipersell,
}
